export const environment = {
  production: false,
  configurationPath: 'assets/config/app.config.json',
  enableAuthentication: true,
  signalRHubConnectionUrl: '/notify'
};
